import { QbBusiness as api } from '../../utils/business/qbbusiness'
import { push } from 'react-router-redux'
import appConst from '../../constant/appConst'

export const GET_ALBUM_REQUEST = 'GET_ALBUM_REQUEST'
export const GET_ALBUM_SUCCESS = 'GET_ALBUM_SUCCESS'
export const GET_ALBUM_ERROR = 'GET_ALBUM_ERROR'
export const getAlbum = (id) => dispatch => {
	dispatch({ type: GET_ALBUM_REQUEST })
	return api.getAlbum(id, 0, appConst.trackListLoadStep)
		.then(response => {
			if (response.status === 'error') {
				dispatch(push('/'))
				dispatch({ type: GET_ALBUM_ERROR, response })
			} else {
				dispatch({
					type: GET_ALBUM_SUCCESS,
					album: response
				})
			}
		})
		.catch(e => {
			push('/')
			dispatch({ type: GET_ALBUM_ERROR, e })
		})
}

export const GET_MORE_TRACKS_ALBUM_REQUEST = 'GET_MORE_TRACKS_ALBUM_REQUEST'
export const GET_MORE_TRACKS_ALBUM_SUCCESS = 'GET_MORE_TRACKS_ALBUM_SUCCESS'
export const GET_MORE_TRACKS_ALBUM_ERROR = 'GET_MORE_TRACKS_ALBUM_ERROR'
export const getMoreTracksAlbum = (id, offset) => dispatch => {
	dispatch({ type: GET_MORE_TRACKS_ALBUM_REQUEST })
	return api.getAlbum(id, offset, appConst.trackListLoadStep)
		.then(response => {
			if (response.status === 'error') {
				dispatch({ type: GET_MORE_TRACKS_ALBUM_ERROR, response })
			} else {
				dispatch({
					type: GET_MORE_TRACKS_ALBUM_SUCCESS,
					album: response
				})
			}
		})
		.catch(e => {
			push('/')
			dispatch({ type: GET_MORE_TRACKS_ALBUM_ERROR, e })
		})
}



// WEBPACK FOOTER //
// ./src/pages/album/albumActions.js